{
  "title": "Tenser's Transformation",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "6th-level transmutation",
  "level": 6,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a few hairs from a bull)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "You endow yourself with endurance and martial prowess fueled by magic. Until the spell ends, you can’t cast spells, and you gain the following benefits:",
    "You gain 50 temporary hit points. If any of these remain when the spell ends, they are lost.",
    "You have advantage on attack rolls that you make with simple and martial weapons.",
    "When you hit a target with a weapon attack, that target takes an extra 2d12 force damage.",
    "You have proficiency with all armor, shields, simple weapons, and martial weapons.",
    "You have proficiency in Strength and Constitution saving throws.",
    "You can attack twice, instead of once, when you take the Attack action on your turn. You ignore this benefit if you already have a feature, like Extra Attack, that gives you extra attacks.",
    "Immediately after the spell ends, you must succeed on a DC 15 Constitution saving throw or suffer one level of exhaustion."
  ],
  "spellLists": ["wizard"]
}
